import { FormattedMessage } from 'react-intl';

import type { BannerState } from './banner-context';
import * as S from './banner.styles';

type ErrorBannerProps = {
  errorState: BannerState;
  handleOnClose?: () => void;
  disableFocusTrap?: boolean;
};

export const ErrorBanner: React.FC<ErrorBannerProps> = ({
  errorState,
  handleOnClose,
  disableFocusTrap,
}) => {
  const { visible, message } = errorState;
  return message ? (
    <S.StatusBanner
      display="fixed"
      show={visible}
      variant="error"
      handleOnClose={handleOnClose}
      focusTrapProps={{ active: !disableFocusTrap }}
    >
      <FormattedMessage
        id={message}
        values={{
          b: (chunks) => <strong>{chunks}</strong>,
        }}
        tagName="span"
      />
    </S.StatusBanner>
  ) : null;
};
